<cs-header>
  <cs-header-title>{{ getPageTitle() }}</cs-header-title>
  <cs-header-content>
    <!-- Top Controls -->
    <div class="controls-row">
      <!-- Category Dropdown -->
      <!-- [ariaLabel] names the dropdown: the search input shares this row, so there is no row
           text the select can take its name from -->
      <cs-select class="category-select" [ariaLabel]="LL.exerciseSwitch.filters.filterByCategory()"
        [value]="searchText.trim() ? 'all' : selectedCategoryId"
        [disabled]="!!searchText.trim()" (selectionChange)="handleCategoryChange($event)">
        <cs-select-option [value]="'all'" [label]="LL.exerciseSwitch.filters.all()"></cs-select-option>
        <cs-select-option [value]="'recommended'" [label]="LL.exerciseSwitch.filters.recommended()">
          @if (getRecommendedSlotId()) {
            <cs-badge color="gray">{{ LL.exerciseSwitch.filters.suggested() }}</cs-badge>
          }
        </cs-select-option>
        <cs-select-option [value]="'myExercises'" [label]="LL.exerciseSwitch.filters.myExercises()"></cs-select-option>
        <!-- slot.slotName is an admin-configured internal exercise-slot name, not display prose -->
        @for (slot of allSlots; track slot._id) {
          <cs-select-option [value]="slot._id" [label]="slot.slotName | untranslated"></cs-select-option>
        }
      </cs-select>

      <!-- Search Input -->
      <cs-input #searchInput class="search-input" iconName="search" autocomplete="off" [(value)]="searchText"
        type="text" name="searchText" inputmode="search" [placeholder]="LL.exerciseSwitch.placeholders.searchExercise()"
        (input)="handleSearchChanged()" />

      <!-- Create Exercise Link -->
      <cs-button tertiary icon="add" (click)="handleCreateExerciseButtonClick()">{{ LL.exerciseSwitch.buttons.createExercise() }}</cs-button>
    </div>

    <!-- Info Alert (only when Recommended filter is selected) -->
    @if (isRecommendedFilterSelected() && getRecommendedSlotId()) {
      <cs-info-card type="info" [dismissible]="false"
        [message]="LL.exerciseSwitch.messages.recommendationInfo()">
      </cs-info-card>
    }
  </cs-header-content>
</cs-header>

<cs-content>

  <!-- Exercise List -->
  <div class="exercise-list-container">
    <!-- Loading Spinner -->
    @if (showSpinner) {
      <div class="loading-spinner">
        <cs-spinner></cs-spinner>
      </div>
    }

    <!-- Exercise Table -->
    @if (!showSpinner) {
      <cs-radio-group [(selected)]="selectedItemId">
        <cs-table class="exercise-table">
          @for (item of displayedUIOptions; track item.exercise._id; let itemIndex = $index) {
            <cs-table-row clickable
              (rowClick)="handleRowClick(item)" [id]="'item-' + item.exercise._id">
              <cs-table-cell class="radio-cell">
                <cs-radio [value]="item.exercise._id"></cs-radio>
              </cs-table-cell>
              <cs-table-cell class="info-cell">
                <div class="exercise-name">
                  {{ item.exercise.name }}
                  @if (isCustomExercise(item.exercise)) {
                    <cs-icon name="person" class="custom-icon"></cs-icon>
                  }
                  @if (item.hasUpdateAvailable) {
                    <span class="update-available-dot" [title]="LL.exerciseSwitch.indicators.updateAvailable()"></span>
                  }
                </div>
                @if (hasAnyBadge(item)) {
                  <div class="badges-row">
                    <!-- Test the STATE key, never the title: the title is translated text, so an
                         English literal here would show this badge to non-English users only (#4368). -->
                    @if (item.stateStateDesc && item.stateStateDesc.state !== 'unused') {
                      <cs-badge [color]="item.stateStateDesc.badgeColor"
                        [label]="item.stateStateDesc.title"
                        [info]="item.stateStateDesc.description"></cs-badge>
                    }
                    @if (item.isCoachAuthored) {
                      <cs-badge color="purple"
                        [label]="coachBadgeLabel()"
                        [info]="coachBadgeInfo(item)"></cs-badge>
                    }
                    @if (item.isFromFormerCoach) {
                      <cs-badge color="gray"
                        [label]="formerCoachBadgeLabel()"
                        [info]="formerCoachBadgeTooltip(item)"></cs-badge>
                    }
                  </div>
                }
              </cs-table-cell>
              <cs-table-cell class="actions-cell" align="right">
                <cs-icon-button icon="ellipsis-vertical" (click)="handleMoreOptions($event, item)"></cs-icon-button>
              </cs-table-cell>
            </cs-table-row>
          }
        </cs-table>
      </cs-radio-group>
    }

    <!-- No Results Empty State -->
    @if (displayedUIOptions.length === 0 && searchText.length > 0 && !showSpinner) {
      <cs-empty-state
        iconName="search"
        [title]="LL.exerciseSwitch.emptyState.noResultsTitle()"
        [subtext]="LL.exerciseSwitch.emptyState.noResultsSubtext()">
      </cs-empty-state>
    }
  </div>
</cs-content>

<cs-page-action-buttons [showCancel]="true" (cancel)="handleCancelButtonClicked($event, ButtonType.Footer)">
  <cs-button medium primary [label]="pageParams?.exerciseId ? LL.exerciseSwitch.buttons.save() : LL.exerciseSwitch.buttons.add()"
    [disabled]="!getSelectedItem()"
  (click)="handleAcceptButtonClicked($event, ButtonType.Footer)"></cs-button>
</cs-page-action-buttons>
